export enum DisciplineStudyReviewStatus {
	Pending = 1,
	Approved = 2,
	Returned = 3,
}
